'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = require('react-router-dom');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var renderWithProps = function renderWithProps(component) {
  for (var _len = arguments.length, passProps = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    passProps[_key - 1] = arguments[_key];
  }

  var combinedProps = Object.assign.apply(Object, [{}].concat(passProps));
  return _react2.default.createElement(component, combinedProps);
};

var RouteProps = function RouteProps(_ref) {
  var component = _ref.component,
      passProps = _objectWithoutProperties(_ref, ['component']);

  return _react2.default.createElement(_reactRouterDom.Route, _extends({}, passProps, { render: function render(routeProps) {
      return renderWithProps(component, routeProps, passProps);
    } }));
};

exports.default = RouteProps;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-route-props/dist/index.js
// module id = 174
// module chunks = 0